export const followUp = {
  button: {
    label: "Faire un suivi",
  },
  header: "Faire un suivi",
  new: "Faire un nouveau suivi",
};
